import { SceneConfigs } from '@flfime/config/SceneConfig';
import { either, equals, ifElse, isNil } from 'ramda';
import { RFNs } from '@flfime/config/SceneConfigTypes';
import { FileName, LazyLoadRenders, createNavigationSlice } from '@oop/data';

const rememberLocation = true;
let lastLocation = rememberLocation
  ? localStorage.getItem('lastLocation') || RFNs['r1']
  : RFNs['r1'];

lastLocation = 'render0000';

export const navigationSlice = createNavigationSlice(
  {
    currentRender: lastLocation,
    loadedRenders: LazyLoadRenders(
      lastLocation,
      [lastLocation],
      SceneConfigs,
      1
    ).map((r) => ({ render: r, fullyLoaded: false })),
    isTransitioning: false,
  },
  RFNs['r0'],
  SceneConfigs,
  RFNs
);

export const {
  goTo,
  setIsTransitioning,
  setRenderLoaded,
} = navigationSlice.actions;
